const affiliates = [
  {
    name: 'KING CONDOR',
    discountOffText: '20%',
    discountTypeText: 'your first order',
    link: 'CONDOR20',
  },
  {
    name: 'ED TALKS',
    discountOffText: '20%',
    discountTypeText: 'your first order',
    link: 'EDTALKS20',
  },
];

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('affiliate-modal');
  const closeModalButton = document.querySelector('.close-affiliates-modal');
  const affiliateName = document.getElementById('affiliate-name');
  const discountOffText = document.getElementById('discount-off-text');
  const discountTypeText = document.getElementById('discount-type-text');

  // Get the original URL from referrer
  const affiliateCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('discount_code='))
    ?.split('=')[1];

  const affiliateModalShown = document.cookie
    .split('; ')
    .find((row) => row.startsWith('affiliate_modal_shown='))
    ?.split('=')[1];

  if (affiliateCookie && affiliateModalShown !== 'true') {
    const matchedAffiliate = affiliates.find((affiliate) => affiliate.link.includes(affiliateCookie.toUpperCase()));

    if (matchedAffiliate) {
      // Populate the modal with affiliate details
      affiliateName.textContent = `${matchedAffiliate.name}`;
      discountOffText.textContent = `${matchedAffiliate.discountOffText}`;
      discountTypeText.textContent = `${matchedAffiliate.discountTypeText}`;

      // Show the modal
      modal.style.display = 'flex';

      // Set affiliate_modal_shown cookie
      const date = new Date();
      date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
      document.cookie = `affiliate_modal_shown=true; expires=${date.toUTCString()}; path=/`;

      // Close the modal when the button is clicked
      closeModalButton.addEventListener('click', function () {
        modal.style.display = 'none';
      });

      // Close the modal when clicking outside the content
      window.addEventListener('click', function (e) {
        if (e.target === modal) {
          modal.style.display = 'none';
        }
      });
    }
  }
});
